export const waitForTargetMount = async (
  selector: string,
  waitTime = 500,
  checkInterval = 50
): Promise<boolean> => {
  if (!selector) {
    return false;
  }

  const maxChecks = waitTime / checkInterval;

  for (let i = 0; i < maxChecks; i++) {
    await new Promise((resolve) => setTimeout(resolve, checkInterval));
    const element = document.querySelector(selector);
    if (element && document.contains(element)) {
      return true;
    }
  }

  return false;
};
